import {
  Annotation,
  AnnotationBase,
  ExperimentType,
  ExperimentTypeForCredits,
  LabelType,
} from '../types';

export const convertLabelTypeToExperimentType = (labelType: LabelType): ExperimentType => {
  switch (labelType) {
    case LabelType.BoundingBox:
      return ExperimentType.ObjectDetection;
    case LabelType.AnomalyDetection:
      return ExperimentType.AnomalyDetection;
    case LabelType.Classification:
      return ExperimentType.Classification;
    case LabelType.Segmentation:
      return ExperimentType.Segmentation;
    case LabelType.SegmentationInstantLearning:
      return ExperimentType.SegmentationInstantLearning;
    default:
      throw new Error('All label type should be mapped');
  }
};

export const getAnomalyDetectionPredictionAnnotations = (
  annotations: Annotation[] | AnnotationBase[] | undefined,
  threshold: number,
) => {
  const anomalyDetectionAnnotation = annotations
    ?.filter(annotation => {
      if (annotation.confidence === undefined) {
        return false;
      }
      return annotation?.confidence <= threshold;
    })
    .sort((a, b) => (a.confidence as number) - (b.confidence as number));
  const predictionAnnotation =
    anomalyDetectionAnnotation && anomalyDetectionAnnotation.length > 0
      ? anomalyDetectionAnnotation?.slice(-1)
      : [];
  return predictionAnnotation;
};

export const convertLabelTypeToExperimentTypeForCredits = (
  labelType: LabelType,
): ExperimentTypeForCredits => {
  switch (labelType) {
    case LabelType.BoundingBox:
      return ExperimentTypeForCredits.ObjectDetection;
    case LabelType.AnomalyDetection:
      return ExperimentTypeForCredits.AnomalyDetection;
    case LabelType.Classification:
      return ExperimentTypeForCredits.Classification;
    case LabelType.Segmentation:
      return ExperimentTypeForCredits.Segmentation;
    case LabelType.SegmentationInstantLearning:
      return ExperimentTypeForCredits.SegmentationInstantLearning;
    default:
      throw new Error('All label type should be mapped');
  }
};
